import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

type InputDateMaskContextProps = {
  isInputDatePickerParent: boolean;
  isDropdownOpen: boolean;
};

/**
 * Context used to indicate when the component is being used in
 * composition within some parent, such as InputDatePicker.
 */
const InputDateMaskContext = createContext<InputDateMaskContextProps>({
  isInputDatePickerParent: false,
  isDropdownOpen: false
});

const useInputDateMaskContext = () => useContext(InputDateMaskContext);

export { InputDateMaskContext, useInputDateMaskContext };
export type { InputDateMaskContextProps };
